// alertTypes.js
//
// Mirrors ALERT_TYPES and GHANA_REGIONS in mysafeghana-user/src/App.js —
// kept in sync manually, no shared package (same pattern already used for
// ghanaRegionsDistricts.js and the password policy across these repos).
// Powers the type/region pickers in AlertsView's "Send Alert" form.

export const ALERT_TYPES = [
  { id:"heavy-rain",    label:"Heavy Rainfall",        icon:"🌧️", severity:"warning",  desc:"Severe rainfall warning. Risk of flooding and reduced visibility." },
  { id:"flood",         label:"Flash Flood",           icon:"🌊", severity:"critical", desc:"Flash flood alert. Avoid low-lying areas and waterways." },
  { id:"extreme-heat",  label:"Extreme Heat",          icon:"☀️", severity:"warning",  desc:"Dangerous heat conditions. Stay hydrated and avoid direct sun." },
  { id:"harmattan",     label:"Harmattan Dust Storm",  icon:"💨", severity:"advisory", desc:"Heavy dust haze. Poor visibility. Cover nose and mouth." },
  { id:"wildfire",      label:"Wildfire / Bush Fire",  icon:"🔥", severity:"critical", desc:"Active wildfire reported. Evacuate affected areas immediately." },
  { id:"robbery",       label:"Live Robbery",          icon:"🚨", severity:"critical", desc:"Active armed robbery in progress. Avoid the area. Call 191." },
  { id:"shooting",      label:"Shooting / Gunfire",    icon:"🎯", severity:"critical", desc:"Shots fired reported. Seek shelter immediately. Call 191." },
  { id:"kidnapping",    label:"Kidnapping Alert",      icon:"⚠️", severity:"critical", desc:"Kidnapping alert issued. Be vigilant. Contact police immediately." },
  { id:"road-accident", label:"Road Accident",         icon:"🚗", severity:"warning",  desc:"Serious road accident. Emergency services deployed. Avoid route." },
  { id:"road-closure",  label:"Road Closure",          icon:"🚧", severity:"advisory", desc:"Road closed due to emergency or construction. Seek alternate route." },
  { id:"power-outage",  label:"Power Outage",          icon:"⚡", severity:"advisory", desc:"Widespread power outage reported. ECG is working to restore supply." },
  { id:"gas-leak",      label:"Gas / Chemical Leak",   icon:"☣️", severity:"critical", desc:"Hazardous gas or chemical leak. Evacuate immediately. Do not use fire." },
  { id:"stampede",      label:"Crowd Stampede",        icon:"🏃", severity:"critical", desc:"Crowd crush / stampede reported. Avoid crowded areas." },
  { id:"epidemic",      label:"Disease Outbreak",      icon:"🦠", severity:"warning",  desc:"Disease outbreak alert. Follow public health guidelines." },
  { id:"missing-person",label:"Missing Person",        icon:"🔍", severity:"advisory", desc:"Missing person alert issued. Contact police with any information." },
  { id:"tsunami",       label:"Tsunami / Coastal Alert",icon:"🌊", severity:"critical", desc:"Coastal hazard alert. Move inland immediately to higher ground." },
];

export const GHANA_REGIONS = [
  { id:"greater-accra", name:"Greater Accra" },
  { id:"ashanti",       name:"Ashanti" },
  { id:"eastern",       name:"Eastern" },
  { id:"central",       name:"Central" },
  { id:"western",       name:"Western" },
  { id:"volta",         name:"Volta" },
  { id:"northern",      name:"Northern" },
  { id:"upper-east",    name:"Upper East" },
  { id:"upper-west",    name:"Upper West" },
  { id:"bono",          name:"Bono" },
  { id:"bono-east",     name:"Bono East" },
  { id:"ahafo",         name:"Ahafo" },
  { id:"savannah",      name:"Savannah" },
  { id:"north-east",    name:"North East" },
  { id:"oti",           name:"Oti" },
  { id:"western-north", name:"Western North" },
];

export const SEVERITY_COLORS = { critical: "#C62828", warning: "#E65100", advisory: "#1565C0" };
